import React from 'react';
import './Spinner.css';
const Spinner = () => {
	return <div className="loader" />;
};

export default Spinner;
